// 剖切相关
const ClipTool = () => {
  return import('../../../components/basic/ClipTool')
}

// 风险隐患
const RiskHiddenDanger = () => {
  return import('../../../components/basic/RiskHiddenDanger')
}

// 风险隐患详情
const DangerHiddenDetails = () => {
  return import('../../../components/business/DangerHiddenDetails/DangerHiddenDetail')
}
// 风险区域详情
const RiskAreaDetails = () => {
  return import('../../../components/business/DangerHiddenDetails/RiskAreaDetail')
}
// 区域风险分级管控清单
const RiskAreaEvalutionStatistics = () => {
  return import('../../../components/business/DangerHiddenDetails/RiskAreaEvalutionStatistics')
}

// 建筑操作
const BuildingOperation = () => {
  return import('../../../components/business/BuildingOperation')
}

// 智能管控
const IntelligentControl = () => {
  return import('../../../components/business/IntelligentControl')
}
// 智能管控大亚湾
const IntelligentControlDyw = () => {
  return import('../../../components/business/IntelligentControlDyw')
}
// 访客信息
const VisitorDetail = () => {
  return import('../../../components/business/VisitorDetail')
}

// 人员信息
const PersonnelInfo = () => {
  return import('../../../components/business/PersonnelInfo')
}

// 电子围栏详情
const ElectronicFenceInfo = () => {
  return import('../../../components/business/ElectronicFenceInfo')
}
// 安防一张图
const SmartSecurityPage = () => {
  return import('../../../components/business/SmartSecurityPage')
}
// 安防一张图-摄像头列表
const ScameraList = () => {
  return import('../../../components/business/components/smartSecurity/scameraList')
}
// 安防一张图-门禁道匝列表
const AccessControlGateList = () => {
  return import('../../../components/business/components/smartSecurity/accessControlGateList')
}
// 安防一张图-门禁列表
const AccessDoorControlGateList = () => {
  return import('../../../components/business/components/smartSecurity/accessDoorControlGateList')
}
// 安防一张图-环境监测列表
const EnvironmentalMonitoringList = () => {
  return import('../../../components/business/components/smartSecurity/environmentalMonitoringList')
}
// 安防一张图-预制处置卡
const DisposalCard = () => {
  return import('../../../components/business/components/smartSecurity/disposalCard')
}
// 作业安全详情
const JobCardDetails = () => {
  return import('../../../components/business/components/jobCardDetails')
}
// 巡检点
const InspectPoint = () => {
  return import('../../../components/business/InspectPoint')
}
// 巡检路线
const InspectRoute = () => {
  return import('../../../components/business/InspectRoute/index')
}
// 巡检二级菜单
const InspectRight = () => {
  return import('../../../components/business/InspectRoute/InspectRight')
}
// SIS系统
const SisSystem = () => {
  return import('../../../components/business/SisSystem/index')
}
// SIS系统 二级菜单-设备列表
const DeviceList = () => {
  return import('../../../components/business/SisSystem/DeviceList')
}

// 富县人员定位
const FuxianPersonList = () => {
  return import('../../../components/business/Fuxian/FuxianPersonList')
}
// 富县人员信息
const FuxianPersonnelInfo = () => {
  return import('../../../components/business/Fuxian/FuxianPersonnelInfo')
}
// 富县两票
const FuxianTwoTicket = () => {
  return import('../../../components/business/Fuxian/FuxianTwoTicket')
}

// 设备台账
const DeviceLedger = () => {
  return import('../../../components/business/DeviceLedger/index')
}
// 设备台账 二级菜单-设备实时监测信息
const DeviceRealTimeInfo = () => {
  return import('../../../components/business/DeviceLedger/DeviceRealTimeInfo')
}
// 设备台账 二级菜单-设备基础信息
const DeviceRealBasicInfo = () => {
  return import('../../../components/business/DeviceLedger/DeviceRealBasicInfo')
}
// 设备台账 二级菜单-设备关联文档
const DeviceDocs = () => {
  return import('../../../components/business/DeviceLedger/DeviceDocs')
}
// 设备台账 二级菜单-设备缺陷记录
const DeviceDefectRecord = () => {
  return import('../../../components/business/DeviceLedger/DeviceDefectRecord')
}
// 设备台账 二级菜单-检修记录
const DeviceMaintainRecord = () => {
  return import('../../../components/business/DeviceLedger/DeviceMaintainRecord')
}
// 设备台账 二级菜单-关联监控
const DeviceMonitor = () => {
  return import('../../../components/business/DeviceLedger/DeviceMonitor')
}
// 设备台账 二级菜单-设备属性
const DeviceInfo = () => {
  return import('../../../components/business/DeviceLedger/DeviceInfo')
}

// 设备台账 二级菜单-设备属性
const DeviceOtherInfo = () => {
  return import('../../../components/business/DeviceLedger/DeviceOtherInfo')
}

// 设备诊断
const DeviceDiagnostics = () => {
  return import('../../../components/business/DeviceDiagnostics/index')
}

// 设备诊断详情
const DeviceDiagnosticsDetail = () => {
  return import('../../../components/business/DeviceDiagnostics/DeviceDiagnosticsDetail')
}

// 热工实验室一张图 --样品信息
const SampleInformation = () => {
  return import('../../../components/business/LabAPicture/SampleInformation')
}
// 实验室一张图 --最新检定任务
const TheNewCheckTask = () => {
  return import('../../../components/business/LabAPicture/TheNewCheckTask')
}

// 电缆桥架
const BridgeCable = () => {
  return import('../../../components/business/BridgeCable/index')
}

// 金属BIM一级
const MetalBim = () => {
  return import('../../../components/business/metal/MetalBimList')
}
// 金属BIM二级
const MetalBimChild = () => {
  return import('../../../components/business/metal/MetalBimChild')
}
// 金属BIM预警列表
const MetAlalertList = () => {
  return import('../../../components/business/metal/MetAlalertList')
}
// 平台监测
const PlatformMonitor = () => {
  return import('../../../components/business/PlatformMonitor/index')
}
// 巡检一张图
const InspectionAPicture = () => {
  return import('../../../components/business/InspectionAPicture/index')
}
// 巡检一张图-机器人清单
const RobotList = () => {
  return import('../../../components/business/InspectionAPicture/RobotList')
}
// 巡检一张图-传感器清单
const SensorList = () => {
  return import('../../../components/business/InspectionAPicture/SensorList')
}
// 巡检一张图-视频清单
const VideoRecognitionList = () => {
  return import('../../../components/business/InspectionAPicture/VideoRecognitionList')
}
// 巡检一张图-巡检点位清单
const PointList = () => {
  return import('../../../components/business/InspectionAPicture/PointList')
}
// 巡检一张图-巡检记录
const Recording = () => {
  return import('../../../components/business/InspectionAPicture/Recording')
}
// 巡检一张图-巡检异常
const Abnormal = () => {
  return import('../../../components/business/InspectionAPicture/Abnormal')
}
// 两票作业
const TwoWork = () => {
  return import('../../../components/business/twoVote/TwoWork')
}
// 交接班
const ShiftConfig = () => {
  return import('../../../components/business/ShiftConfig/ShiftConfig')
}
// 应急处置一张图
const EmergencyDisposal = () => {
  return import('../../../components/business/EmergencyDisposal/index')
}
// 应急处置一张图-预案列表
const PlanList = () => {
  return import('../../../components/business/EmergencyDisposal/PlanList')
}
// 应急物资台账
const EmergencyMatter = () => {
  return import('../../../components/business/EmergencyDisposal/EmergencyMatter')
}
// 疏散通道路径
const EscapeRoute = () => {
  return import('../../../components/business/EmergencyDisposal/EscapeRoute')
}
// 安全岛台账
const SafetyIsland = () => {
  return import('../../../components/business/EmergencyDisposal/SafetyIsland')
}
// 应急处置卡
const EmergencyDisposalCard = () => {
  return import('../../../components/business/EmergencyDisposal/EmergencyDisposalCard')
}
// 应急监控
const EmergencyMonitor = () => {
  return import('../../../components/business/EmergencyDisposal/EmergencyMonitor')
}
// 移交对象
const HandoverObject = () => {
  return import('../../../components/business/HandoverObject')
}
// 对象信息
const ObjectInfo = () => {
  return import('../../../components/business/ObjectInfo/index')
}
// 移交文档
const HandoverDocuments = () => {
  return import('../../../components/business/HandoverDocuments')
}
// 物资详情
const MaterialInfo = () => {
  return import('../../../components/business/EmergencyDisposal/Material')
}
// 缺陷管理
const DefectManage = () => {
  return import('../../../components/business/DefectManage/index')
}
// 缺陷详情
const DefectDetail = () => {
  return import('../../../components/business/DefectManage/DefectDetail')
}
// 进度模拟
const ProgressSimulation = () => {
  return import('../../../components/business/Progress/ProgressSimulation')
}
// 照明一张图
const Lighting = () => {
  return import('../../../components/business/Lighting/index')
}
// 照明一张图-设备清单
const LightingDeviceList = () => {
  return import('../../../components/business/Lighting/lightingDeviceList')
}

const exportComponents = {
  MonitorList: () => {
    return import('../../../components/business/MonitorList/MonitorList.vue')
  },
  TsgPersonInfo: () => {
    return import('../../../components/business/PersonPosition/personInfo.vue')
  },
  // 人员定位
  TsgPersonPosition: () => {
    return import('../../../components/business/PersonPosition/personPosition.vue')
  },
  TaskInfo: () => {
    return import('../../../components/business/TaskMessage/TaskInfo')
  },
  QualityList: () => {
    return import('../../../components/business/QualityControl/QualityList')
  },
  QualityInfo: () => {
    return import('../../../components/business/QualityControl/QualityInfo')
  },
  VideoList: () => {
    return import('../../../components/business/VideoMonitor/VideoList')
  },
  VideoInfo: () => {
    return import('../../../components/business/VideoMonitor/VideoInfo')
  },
  CameraList: () => {
    return import('../../../components/business/MonitorList/CameraList')
  },
  CameraInfo: () => {
    return import('../../../components/business/MonitorList/CameraInfo')
  },
  NearbyCameras: () => {
    return import('../../../components/business/MonitorList/NearbyCameras')
  },
  ModelTree: () => {
    return import('../../../components/basic/ModelTree')
  },
  PreferenceSetting: () => {
    return import('../../../components/basic/PreferenceSetting')
  },
  GlobalSetting: () => {
    return import('../../../components/basic/GlobalSetting')
  },
  UnderClip: () => {
    return import('../../../components/basic/UnderClip')
  },
  ProcessSimulate: () => {
    return import('../../../components/business/ProcessSimulate')
  },
  OperationSafetyPage: () => {
    return import('../../../components/business/OperationSafetyPage')
  },
  // 以下为广西定制功能 start
  // 流向分析
  PipeFlowAnalysis: () => {
    return import('../../../components/business/PipeFlowAnalysis/index')
  },
  // 管线抽离
  PipeExtraction: () => {
    return import('../../../components/business/PipeExtraction')
  },
  // 三维寻阀
  ValveManagement: () => {
    return import('../../../components/business/ValveManagement/PipeList')
  },
  // 三维寻阀-阀门列表
  ValveList: () => {
    return import('../../../components/business/ValveManagement/ValveList')
  },
  // 防腐保温
  AnticorrosionAndInsulation: () => {
    return import('../../../components/business/AnticorrosionAndInsulation/PipeList')
  },
  // 防腐保温-材料详情
  PrtMaterialDetail: () => {
    return import('../../../components/business/AnticorrosionAndInsulation/PrtMaterialDetail')
  },
  // 物料统计
  MaterialStatistics: () => {
    return import('../../../components/business/MaterialStatistics/PipeList')
  },
  // 物料统计-关联物料清单
  AssociatedMaterial: () => {
    return import('../../../components/business/MaterialStatistics/AssociatedMaterial')
  },
  // 断面分析
  CrossSectionAnalysis: () => {
    return import('../../../components/business/CrossSectionAnalysis/index')
  },
  // 盲板综合展示
  BlindPlateExhibition: () => {
    return import('../../../components/business/BlindPlateExhibition/BlindPlateList')
  },
  // 三查四定
  ChecksAndSets: () => {
    return import('../../../components/business/ChecksAndSets/ProblemList')
  },
  // 以上为广西定制功能 end

  // 质量安全管理
  SafetyQualityManagement: () => {
    return import('../../../components/business/SafetyQuality/list')
  },
  // 质量安全详情
  SafetyQualityDetail: () => {
    return import('../../../components/business/SafetyQuality/detail')
  },
  // 作业一张图
  WorkAPicture: () => {
    return import('../../../components/business/WorkAPicture/WorkAPicture')
  },
  // 作业列表
  WorkList: () => {
    return import('../../../components/business/WorkAPicture/WorkList')
  },
  // 电气第一张工作票
  ElectricalWorkVote: () => {
    return import('../../../components/business/WorkAPicture/ElectricalWorkVote')
  },
  // 智慧安防
  SmartSecurity: () => {
    return import('../../../components/business/SmartSecurity/SmartSecurity.vue')
  },
  // 预警处置卡
  EarlyWarningDisposalCard: () => {
    return import('../../../components/business/SmartSecurity/EarlyWarningDisposalCard.vue')
  },
  // 视觉列表
  ListOfPerspectives: () => {
    return import('../../../components/business/ListOfPerspectives/ListOfPerspectives.vue')
  },
  // 碰撞检查
  CollisionCheck: () => {
    return import('../../../components/business/CollisionCheck/index')
  },
  // 新建碰撞检查
  NewCollisionCheck: () => {
    return import('../../../components/business/CollisionCheck/NewCollisionCheck')
  },

  AllClip: ClipTool,
  PartClipBox: ClipTool,
  ThreePanel: ClipTool,
  RiskHiddenDanger,
  DangerHiddenDetails,
  RiskAreaDetails,
  RiskAreaEvalutionStatistics,
  BuildingOperation,
  PersonPosition: IntelligentControl,
  PersonPositionDyw: IntelligentControlDyw,
  PersonnelInfo,
  VisitorDetail,
  ElectronicFenceInfo,
  SmartSecurityPage,
  ScameraList,
  AccessControlGateList,
  AccessDoorControlGateList,
  EnvironmentalMonitoringList,
  DisposalCard,
  JobCardDetails,
  InspectPoint,
  InspectRoute,
  SisSystem,
  FuxianPersonList,
  FuxianPersonnelInfo,
  FuxianTwoTicket,
  DeviceLedger,
  DeviceRealTimeInfo,
  DeviceRealBasicInfo,
  DeviceDocs,
  DeviceDefectRecord,
  DeviceMaintainRecord,
  DeviceMonitor,
  DeviceInfo,
  DeviceOtherInfo,
  DeviceDiagnostics,
  DeviceDiagnosticsDetail,
  SampleInformation,
  TheNewCheckTask,
  BridgeCable,
  InspectRight,
  DeviceList,
  MetalBim,
  MetalBimChild,
  PlatformMonitor,
  MetAlalertList,
  ShiftConfig,
  EmergencyDisposal,
  PlanList,
  EmergencyMatter,
  EscapeRoute,
  SafetyIsland,
  EmergencyDisposalCard,
  EmergencyMonitor,
  TwoWork,
  HandoverObject,
  ObjectInfo,
  HandoverDocuments,
  MaterialInfo,
  DefectManage,
  DefectDetail,
  ProgressSimulation,
  Lighting,
  LightingDeviceList,
  InspectionAPicture,
  RobotList,
  VideoRecognitionList,
  SensorList,
  PointList,
  Abnormal,
  Recording,
}
export default exportComponents
